import React from 'react';
import { SxProps } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { JOB_MANAGER_PATHS } from 'constants/job-manager-paths';
import { CreateFormFeatureDialog } from 'components';
import { jobsConfig } from './create-job-dialog-helper';

interface CreateJobDialogProps {
    children: React.ReactNode;
    handleSubmit: () => void;
    buttonText: string;
    displaySubmitButton?: boolean;
    handleCustomBackClick?: () => void;
    handleCustomCloseClick?: () => void;
    customStyles?: SxProps;
    isLoading?: boolean;
    customButtonContainerStyles?: SxProps;
}

export const CreateJobDialog = ({
    children,
    handleSubmit,
    buttonText,
    displaySubmitButton = true,
    handleCustomBackClick,
    handleCustomCloseClick,
    customStyles,
    isLoading = false,
    customButtonContainerStyles,
}: CreateJobDialogProps): React.JSX.Element => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const handleCloseButton = (): void => {
        if (handleCustomCloseClick) {
            handleCustomCloseClick();
        } else {
            navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
        }
    };

    const handleBackButton = (): void => {
        if (handleCustomBackClick) {
            handleCustomBackClick();
        } else {
            /**
             * Check whether we landed in this component from the dictionaries create view or just via
             * normal job manager flow. If we got here via dictionaries, make sure we send the user back
             * to the previous dictionaries screen. Otherwise, navigate them to the job manager landing page.
             */
            const dictionariesCreateView = searchParams.get(
                'create-dictionary-view'
            );
            navigate(
                dictionariesCreateView ?? JOB_MANAGER_PATHS.CREATE_NEW_JOB
            );
        }
    };

    return (
        <CreateFormFeatureDialog
            buttonText={buttonText}
            handleSubmit={handleSubmit}
            displaySubmitButton={displaySubmitButton}
            customStyles={customStyles}
            isLoading={isLoading}
            handleCloseButton={handleCloseButton}
            handleBackButton={handleBackButton}
            listConfig={jobsConfig}
            customButtonContainerStyles={customButtonContainerStyles}
        >
            {children}
        </CreateFormFeatureDialog>
    );
};
